import React, { Component } from 'react'
import moment from 'moment'

import { envConstants } from '../../constants'
import { holeHelper } from '../../helpers'

class Line extends Component {
  isChecked() {
    const d = this.props.d
    const c = this.props.chkList
    return c.filter((x) => x === d.id).length > 0 ? 'checked' : ''
  }

  render() {
    const d = this.props.d
    // <ul className={'detection-container '}>
    return (
      <ul
        className={'detection-container ' + this.isChecked()}
        onClick={(e) => this.props.setChecked(e, d)}
      >
        <li className='severity'>
          <img src={holeHelper.holeStatusMarker(d)} alt={d.status} />
        </li>
        <li className='id'>
          {d.id}
          <button
            onClick={() => this.props.handleClickDetails(d.id)}
            aria-label='Info'
          >
            <i className='fas fa-info-circle'></i>
          </button>
        </li>
        <li className='address'>{d.formattedAddress}</li>
        <li className='ld'>
          {moment.unix(d.lastDetection).format(envConstants.momentFormat)}
        </li>
        <li className='type'>{d.anomalyType}</li>
        <li className='severity'>
          <img src={holeHelper.holeMarker(d)} alt={d.severity} />
        </li>
        <li className='id'>
          <button
            name='resolved'
            disabled={d.status < 2}
            className='lnk-resolved'
            onClick={(e) => this.props.setResolved(e, d)}
          >
            {d.status === 3 && 'non '} Risolta
          </button>
        </li>
      </ul>
    )
  }
}

export default Line
